import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const apiReopenReserveList = (reserveListId: string) => {
    return http
        .put(
            reservesConfig().endpointReserveListReopen,
            {},
            {
                pathParams: {
                    reserveListId
                }
            }
        )
        .then(response => response.data);
};
